import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PropertyService } from '../../../services/property.service';
import { PropertyInitialSubject } from '../../../subject/property.initial.subject';
import { PropertySearchMapper } from '../../../mappers/property-search.mapper';
import { PropertySearchCardVM } from '../../../models/property-search-card.vm';

@Component({
  selector: 'app-property-success',
  templateUrl: './property-success.component.html',
  styleUrls: ['./property-success.component.scss']
})
export class PropertySuccessComponent implements OnInit {

  propertyId?: number;
  cardVm: PropertySearchCardVM | null = null;
  loading = true;

  constructor(
    private router: Router,
    private propertyService: PropertyService,
    private propertyInitialSubject: PropertyInitialSubject,
    private cardMapper: PropertySearchMapper
  ) {}

  ngOnInit(): void {
    const property = this.propertyInitialSubject.getCurrentProperty();
    this.propertyId = property?.propertyId;
    if (!this.propertyId) { this.loading = false; return; }

    // La propiedad ya quedó COMPLETED_PROP al concluir → la traemos con su shape de card real.
    this.propertyService.getDetailProperty(this.propertyId).pipe(
      catchError(() => of(null))
    ).subscribe((dto: any) => {
      this.cardVm = dto ? this.cardMapper.toCardVM(dto) : null;
      this.loading = false;
    });
  }

  /** Click en el card → previsualizar la propiedad publicada. */
  previewProperty(propertyId: number): void {
    this.router.navigate(['/property', propertyId]);
  }

  goToMyProperties(): void { this.router.navigate(['/list']); }

  uploadNewProperty(): void { this.router.navigate(['/welcome']); }
}
